import {CounterLabel} from '@primer/react'
import type {FC} from 'react'
import {Finding} from './Finding'
import styles from './FindingsSection.module.css'
import type {Finding as FindingType} from './types'

interface FindingsSectionProps {
  title: string
  slug: string
  findings: FindingType[]
  resolved: boolean
  onDismiss: (finding: FindingType) => void
  onReopen: (finding: FindingType) => void
  onFix: (finding: FindingType) => void
  fixTaskIds: Record<string, string>
  taskBasePath: string
  feedbackPath: string
}

export const FindingsSection: FC<FindingsSectionProps> = ({
  title,
  slug,
  findings,
  resolved,
  onDismiss,
  onReopen,
  onFix,
  fixTaskIds,
  taskBasePath,
  feedbackPath,
}) => (
  <section aria-labelledby={`section-${slug}`} className="tmp-mb-3">
    <h3 className={styles.sectionHeader} id={`section-${slug}`}>
      {title}
      <CounterLabel>{findings.length}</CounterLabel>
    </h3>
    <ul aria-label={title}>
      {findings.map(finding => (
        <Finding
          key={finding.id}
          finding={finding}
          resolved={resolved}
          onDismiss={() => onDismiss(finding)}
          onReopen={() => onReopen(finding)}
          onFix={() => onFix(finding)}
          taskId={fixTaskIds[finding.id] ?? finding.taskId}
          taskBasePath={taskBasePath}
          feedbackPath={feedbackPath}
        />
      ))}
    </ul>
  </section>
)
